import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Success from "@/pages/Success";
import Studio from "@/pages/Studio";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Toaster position="top-center" richColors closeButton />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/success" element={<Success />} />
                    <Route path="/studio" element={<Studio />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
